// Facebook Pixel, Cortex-only (designer 46542). fbevents.js is injected on demand the first
// time a Cortex-gated event fires, so non-Cortex pages never load the pixel at all.
const CORTEX_PIXEL_ID = "362732092065896";

function ensurePixel() {
  if (window.fbq) {
    return;
  }
  const n = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  });
  if (!window._fbq) {
    window._fbq = n;
  }
  n.push = n;
  n.loaded = true;
  n.version = "2.0";
  n.queue = [];
  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  const first = document.getElementsByTagName("script")[0];
  first.parentNode.insertBefore(script, first);
  window.fbq("init", CORTEX_PIXEL_ID);
}

export function trackCortexPixel(event, params) {
  ensurePixel();
  window.fbq("trackSingle", CORTEX_PIXEL_ID, event, params);
}
